import { CommonModule, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';
import { ComumModule } from './../../../shared/comum.module';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { MoedaCadastroComponent } from './moeda-cadastro/moeda-cadastro.component';
import { MoedaFiltroComponent } from './moeda-filtro/moeda-filtro.component';
import { MoedaListaComponent } from './moeda-lista/moeda-lista.component';
import { MoedaService } from './moeda-service/moeda.service';
import { MoedaComponent } from './moeda.component';



@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TreeTableModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    FileUploadModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    OsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    MoedaComponent
  ],
  declarations: [
    MoedaComponent,
    MoedaCadastroComponent, 
    MoedaFiltroComponent, 
    MoedaListaComponent
  ],
  providers: [
    MoedaService,
    DecimalPipe
  ]
})
export class MoedaModule { }
